/* eslint-disable import/no-default-export, import/order, max-lines, max-lines-per-function, no-nested-ternary, react/no-unescaped-entities, react/prop-types, react/display-name */
import { useRef, forwardRef, useImperativeHandle } from "react";
import { cn } from "tailwind-variants";
import UseSvg from "common/vue/components/UseSvg.react.vue";

export default forwardRef(
  (
    { title, onHowItWorksClick, onHowItWorksMouseenter, onHowItWorksMouseleave, ...restProps }: any,
    ref: any
  ) => {
    const howItWorksButtonRef = useRef(null);

    useImperativeHandle(ref, () => ({
      howItWorksButtonRef: howItWorksButtonRef.current
    }));

    return (
      <div {...restProps} className={cn("flex items-center gap-1.5", restProps.className)}>
        <UseSvg className="h-6 w-6 shrink-0" icon="sparkles-gradient" data-testid="h-6" />
        <h3 className="text-sm !font-medium leading-6 text-neutral-950">{title}</h3>
        <span className="rounded-full border border-white bg-green-700 px-1.5 py-0.5 text-xs font-medium text-white">
          {" "}
          Free{" "}
        </span>
        <div className="ml-auto">
          <button
            className="cursor-pointer border-0 bg-transparent p-0 text-xs !text-blue-700 underline"
            ref={howItWorksButtonRef}
            type="button"
            data-testid="how-it-works-button"
            onClick={() => {
              onHowItWorksClick?.();
            }}
            onMouseEnter={() => {
              onHowItWorksMouseenter?.();
            }}
            onMouseLeave={() => {
              onHowItWorksMouseleave?.();
            }}
          >
            {" "}
            How it works{" "}
          </button>
        </div>
      </div>
    );
  }
);
